/**
 * Format a US phone as the user types: '(XXX) XXX-XXXX'.
 * Accepts any digits/non-digits and returns the masked value.
 */
export const formatUsPhone = (raw) => {
  const digits = String(raw ?? '').replace(/\D/g, '').slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3)  return `(${digits}`;
  if (digits.length <= 6)  return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

/** Returns true when the input has exactly 10 US digits. */
export const isValidUsPhone = (raw) =>
  String(raw ?? '').replace(/\D/g, '').length === 10;

/** Strict canonical form used by the backend. */
export const canonicalUsPhone = (raw) => {
  const digits = String(raw ?? '').replace(/\D/g, '').slice(-10);
  if (digits.length !== 10) return '';
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};
